/**
 * Advanced Search - Módulo para la búsqueda avanzada de facturas recibidas
 */
import $ from 'jquery';
import 'select2';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { Spanish } from 'flatpickr/dist/l10n/es';
export class AdvancedSearch {
    constructor() {
        this.FORM_ID = '#advancedSearchForm';
        this.formElement = null;
        this.init();
    }
    init() {
        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', () => {
                this.initializeModule();
            });
        }
        else {
            this.initializeModule();
        }
    }
    initializeModule() {
        this.formElement = document.querySelector(this.FORM_ID);
        if (!this.formElement) {
            return;
        }
        this.initializeSelect2();
        this.initializeDatePickers();
        this.loadSavedFilters();
    }
    initializeSelect2() {
        const selectElements = document.querySelectorAll('.select2');
        selectElements.forEach((select) => {
            const element = select;
            $(element).select2({
                theme: 'bootstrap-5',
                width: '100%',
                placeholder: element.getAttribute('placeholder') || 'Seleccionar opciones'
            });
        });
    }
    initializeDatePickers() {
        const calendarInputs = document.querySelectorAll('.calendar');
        calendarInputs.forEach((input) => {
            const element = input;
            flatpickr(element, {
                dateFormat: 'Y-m-d',
                locale: Spanish,
                allowInput: true,
                disableMobile: true
            });
        });
    }
    loadSavedFilters() {
        // Los filtros ya están cargados en el HTML desde PHP
        // Solo necesitamos actualizar los select2 para reflejar los valores seleccionados
        this.updateSelect2FromHtml();
    }
    updateSelect2FromHtml() {
        // Leer los valores seleccionados del HTML y actualizar select2
        const selectElements = document.querySelectorAll('.select2');
        selectElements.forEach((select) => {
            const element = select;
            // Verificar que selectedOptions existe
            if (element.selectedOptions && element.selectedOptions.length > 0) {
                const selectedOptions = Array.from(element.selectedOptions).map(opt => opt.value);
                $(element).val(selectedOptions).trigger('change');
            }
        });
    }
}
export default AdvancedSearch;
